import { CookiePlusOutlineIcon } from './CookiePlusOutlineIcon';

/**
 * author: Colton Wiscombe
 * id AB2BBE22-85B2-4D5B-9F99-099DE970A9EC
 * name cookie-plus-outline
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cookie-plus-outline.svg
 * tags
 * - Food / Drink 
 */
export const BiscuitPlusOutlineIcon = CookiePlusOutlineIcon;
export default BiscuitPlusOutlineIcon